import * as React from "react";
import type { SVGProps } from "react";
const SvgRefresh011 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.816 21.6 2.4 18m0 0 3.416-3.6M2.4 18h16.8a2.4 2.4 0 0 0 2.4-2.4V12m-3.416-9.6L21.6 6m0 0-3.416 3.6M21.6 6H4.8a2.4 2.4 0 0 0-2.4 2.4V12"
    />
  </svg>
);
export default SvgRefresh011;
